import type { MembershipsCreatorApi } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { FormValues } from './types'

export const getUpdateAccountSettingsTiersPayload = (
  formValues: FormValues,
): MembershipsCreatorApi.UpdateGeneralSettings.RequestBody => {
  const {
    annualEnabled,
    freeAccounts,
    contentVisibility,
    membersCountEnabled,
    anualDiscount,
    adultContent,
    audioDownload,
    membershipsVisible,
    gifEnabled,
  } = formValues

  const getAnnualPayload = () => {
    if (annualEnabled && anualDiscount) {
      return {
        annual: {
          percentOff: parseInt(anualDiscount),
        },
      }
    }

    return undefined
  }

  return {
    contentVisibility,
    freeAccounts: {
      displayEnabled: freeAccounts === 'show',
    },
    membersCountEnabled,
    ...getAnnualPayload(),
    adultContent: {
      present: adultContent,
    },
    mediaDownload: {
      audio: {
        enabled: audioDownload,
      },
    },
    membershipsVisibility: {
      public: membershipsVisible,
    },
    gifting: {
      enabled: gifEnabled,
    },
  }
}
